export default __webpack_public_path__ + "static/media/19.09e1adc5.png";